<lottie-player *ngIf="loadingPathJson" autoplay="true"
    [src]="loadingPathJson" loop=""
    speed="1" style="height: fit-content;width: 80px; background: transparent;"
    background="transparent">
</lottie-player>